import axios from 'axios'
import Qs from 'qs'
import store from '../store'

const setShowLoading = (bool)=> {
    store.dispatch({type:'setShowLoading',value:bool})
} 

const request = axios.create({
    // API 请求的默认前缀
   //baseURL: 'http://localhost:9098/apiv1/',
  baseURL: 'https://api.radarbao.xyz/apiv1/',
   

    timeout: 60000 // 请求超时时间
  })

// 异常拦截处理器
const errorHandler = (error) => {
    setShowLoading(false)

    if (error.response) {
      const data = error.response.data



      // 从 localstorage 获取 token
    //   const token = window.acToken
      if (error.response.status === 403) {
          this.$message.error(data.message);
      }
      // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      //   notification.error({
      //     message: 'Unauthorized',
      //     description: 'Authorization verification failed'
      //   })
      //   if (token) {
      //     store.dispatch('Logout').then(() => {
      //       setTimeout(() => {
      //         window.location.reload()
      //       }, 1500)
      //     })
      //   }
      // }
    }
    return Promise.reject(error)
  }

  // request interceptor
request.interceptors.request.use(config => {
  // console.log(config)
  if(config.showLoading==false){
    
  }else{
    setShowLoading(true)
  }
    
    const token = window.pass
    // 如果 token 存在
    // 让每个请求携带自定义 token 请根据实际情况自行修改
    if (token) {
      config.headers['Authorization'] =token
    }

    // config.headers["Content-Type"] = "application/json"
      //
      // if (config.method === 'post' && config.data === undefined  ) {
      //   config.data = Qs.stringify(config.data)
      // }




    return config
  }, errorHandler)

  // response interceptor
request.interceptors.response.use((response) => {
    setShowLoading(false)
    return response.data
  }, errorHandler)

  export default request